import React from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import { format } from "date-fns";
import Heading from "../../../components/Heading/Heading";
import LastOrderPreview from "../../../components/LastOrderPreview/LastOrderPreview";
import MatUITable from "../../../components/MatUITable/MatUITable";
import { UserDashboardContext } from "../UserDashboard";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import axios from "../../../utils/Axios/axiosProxy";
import {
  messageColumnsDashboard,
  ordersColumns,
  proposalsColumns,
  orderLabels,
} from "../../../utils/Data/dataTexts";

const createTableData = (messages) => {
  let rowData = [];
  for (let key in messages.threads) {
    let msgArr = messages.threads[key].messages;
    let length = msgArr.length;
    if (length > 0) {
      let seen =
        msgArr[length - 1].sender === "admin" ? msgArr[length - 1].seen : true;
      rowData.push({
        threadID: messages.threads[key]._id,
        threadIDShort: `${messages.threads[key]._id.substring(0, 10)}... `,
        sent: format(new Date(msgArr[length - 1].date), "yyyy-MM-dd"),
        message: `${msgArr[length - 1].message.substring(0, 15)} ...`,
        dialogData: messages.threads[key],
        seen: seen,
        userID: messages.userID,
        sentSortBy: format(new Date(msgArr[length - 1].date), "yyyy-MM-dd"),
      });
    } else {
      rowData.push({
        threadID: messages.threads[key]._id,
        threadIDShort: `${messages.threads[key]._id.substring(0, 10)}... `,
        sent: format(new Date(), "yyyy-MM-dd"),
        sentSortBy: format(new Date(), "yyyy-MM-dd"),
        message: i18n.t("matable.nomsg"),
        dialogData: messages.threads[key],
        userID: messages.userID,
      });
    }
  }
  return rowData;
};

function Dashboard({ userAccount, orders, handleNavigation }) {
  const dashboardContext = React.useContext(UserDashboardContext);
  const messages = dashboardContext.state.messages;
  const setLastShipment = () => {
    let processed = false;
    for (let i in orders) {
      for (let j in orders[i].etr) {
        if (orders[i].etr[j].length > 0 || orders[i].status !== "processing") {
          processed = true;
        }
      }
      if (processed === true) {
        return orders[i];
      }
    }
    if (processed === false) {
      return orders[0];
    }
  };
  const filterShipmentsFromOrders = () => {
    let processedOrders = [];
    let notProcessedOrders = [];
    orders.forEach((order) => {
      let unseen = 0;
      let processed = false;
      for (let j in order.etr) {
        if (order.etr[j].length > 0 || order.status !== "processing") {
          processed = true;
        }
      }
      if (processed === true) {
        processedOrders.push(order);
      }
      if (processed === false) {
        order.proposal =
          order.quotation && order.quotesent ? (
            window.innerWidth < 600 ? (
              <CloudDownloadIcon
                style={{ color: "#333a7f" }}
                onClick={() => getPDF(order._id)}
              />
            ) : (
              <Button
                onClick={() => getPDF(order._id)}
                className="TransparentBlue Small"
              >
                {i18n.t("general.download")}
              </Button>
            )
          ) : (
            orderLabels.proposalstatus[order.proposalstatus]
          );
        order.proposalstatuslabel =
          orderLabels.proposalstatus[order.proposalstatus];
        order.messages.forEach((message) => {
          if (message.sender === "admin" && !message.seen) {
            unseen += 1;
          }
          order.unseen = unseen;
        });
        notProcessedOrders.push(order);
      }
    });
    return { processed: processedOrders, notProcessed: notProcessedOrders };
  };
  const lastOrder = setLastShipment();

  const getPDF = (id) => {
    axios
      .get(`/pdf/quotation_${id}.pdf`, {
        headers: {
          "Content-Type": "application/pdf",
        },
      })
      .then((response) => {
        window.open(response.data.url, "_blank");
        console.log("GET PDF RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("GET PDF ERROR: ", error);
      })
      .catch((error) => console.log("GET PDF CLIENT ERROR", error));
  };
  const updateOrder = (id, proposalstatus, payment) => {
    let data = {
      proposal: true,
      orderID: id,
      updateParams: {
        proposalstatus: proposalstatus,
        payment: payment,
      },
    };
    axios
      .patch("/api/order/update", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("UPDATE ORDER RESPONSE: ", response.statusText);
        dashboardContext.getUserOrdersMessagesFromDB(
          localStorage.getItem("JWT")
        );
      })
      .catch((error) => {
        console.log("UPDATE ORDER ERROR: ", error.response.data);
      })
      .catch((error) => console.log("submitToDB error", error));
  };
  return (
    <Grid container className="DashboardContent" justify="center" spacing={2}>
      <Modal
        className="FlexCenter"
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={dashboardContext.state.modalOpen}
        onClose={() => dashboardContext.handleClose()}
      >
        <div className="MessagePopupContainer">
          <h2 className="ProfileText">{i18n.t("general.filloutdata")}</h2>
        </div>
      </Modal>
      <Grid item md={11} xs={11}>
        <p className="WelcomeText NoMargin AlignCenter">{`${i18n.t(
          "dashboard.welcome"
        )} ${userAccount.firstname}!`}</p>
      </Grid>
      <LastOrderPreview lastOrder={lastOrder} />
      <Grid item md={4} xs={11}>
        <Heading
          title="Messages"
          titleB={i18n.t("dashboard.seeall")}
          button
          onClick={() => {
            handleNavigation("Support");
          }}
          className="ToreaBay Small"
        />
        <MatUITable
          paging={true}
          pageSize={5}
          page="support"
          columns={messageColumnsDashboard}
          data={createTableData(messages)}
        />
      </Grid>
      <Grid item md={11} xs={11}>
        <Heading
          title={i18n.t("dashboardmenu.shipments")}
          titleB={i18n.t("dashboard.seeall")}
          button
          onClick={() => {
            handleNavigation("Shipments");
          }}
          className="ToreaBay Small"
        />
        <MatUITable
          paging={false}
          pageSize={3}
          page="orders"
          columns={ordersColumns}
          data={filterShipmentsFromOrders().processed}
        />
      </Grid>
      <Grid item md={11} xs={11}>
        <Heading
          title={i18n.t("dashboardmenu.proposals")}
          titleB={i18n.t("dashboard.seeall")}
          button
          onClick={() => {
            handleNavigation("Proposals");
          }}
          className="ToreaBay Small"
        />
        <MatUITable
          paging={false}
          pageSize={3}
          page="proposal"
          updateOrder={updateOrder}
          columns={proposalsColumns}
          data={filterShipmentsFromOrders().notProcessed}
        />
      </Grid>
    </Grid>
  );
}

export default withTranslation()(Dashboard);
